<template>
  <div id="pm_mex_11_merchant_contract_container" class="vx-col sm:w-5/6 xl:w-4/5 xxl:w-2/3 m-0">
    <div class="vx-row no-gutter items-center justify-center p-6">
      <vx-card class="login-card py-3 px-3">
        <div slot="no-body" class="">
          <div class="vx-col px-6 pt-5 pb-5 sm:w-full">
            <div class="vx-row">
              <div :class="colClassFull">
                <vx-card class="mt-base mb-2">
                  <h2 class="mb-5">Lo que dice tu contrato</h2>
                  <p>
                    En resumen, contratas a RedGirasol para ser un intermediario que conecta tu dinero con créditos de
                    financiamiento colectivo de alto impacto.
                  </p>
                  <p class="mt-3 mb-3">
                    Cuando inviertes a través de RedGirasol, te conviertes en el dueño de una fracción del portafolio de
                    créditos.
                  </p>
                  <p>
                    Tu rendimiento proviene directamente de los pagos de los créditos en los que está invertido tu
                    dinero, no de RedGirasol.
                  </p>
                </vx-card>
              </div>
            </div>

            <div class="vx-row match-height">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vx-card class="mb-2">
                  <h4 class="mb-1">Invierte y retira sin comisiones</h4>
                  <ul class="commission-promo-list">
                    <li>
                      Por rendimiento cobrado <span class="line-through">10%</span> &rarr; 0%
                      <a class="inline-link-primary text-dark"
                        href="https://soporte.redgirasol.com/support/solutions/articles/48001276606-descuento-de-la-comisi%C3%B3n-por-%C3%A9xito-en-la-inversi%C3%B3n-redgirasol"
                        target="blank">Consulta la promoción</a>
                    </li>
                    <li>
                      Por retiro de inversión <span class="line-through">2%</span> &rarr; 0%
                      <a class="inline-link-primary text-dark"
                        href="https://soporte.redgirasol.com/support/solutions/articles/48001285298-retira-inversi%C3%B3n-sin-costo"
                        target="blank">Consulta la promoción</a>
                    </li>
                  </ul>
                </vx-card>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vx-card class="mb-2">
                  <h4 class="mb-1">Retira tu dinero 24/7</h4>
                  <p>
                    Podrás retirar hasta <b>$1,000,000</b> al mes con liquidez diaria de {{
                      explicitMoneyFormat(maxEffectiveInvestmentWithdrawalPerInvestorPerDay, 0) }}, sin comisiones.
                  </p>
                </vx-card>
              </div>
            </div>

            <div class="vx-row match-height">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vx-card class="mb-2">
                  <h4 class="mb-1">Inversión mínima de {{
                    explicitMoneyFormat(minimumFixedInvestmentRequiredToSignUpSmMxn, 0) }}</h4>
                  <p>
                    Comienza a crecer tu dinero a partir de {{
                      explicitMoneyFormat(minimumFixedInvestmentRequiredToSignUpSmMxn, 0) }}.
                  </p>
                </vx-card>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vx-card class="mb-2">
                  <h4 class="mb-1">Pagos e interés compuesto diarios</h4>
                  <p>
                    Tus rendimientos diarios se mantienen invertidos y generan interés compuesto cada día.
                  </p>
                </vx-card>
              </div>
            </div>

            <div class="vx-row mt-base">
              <div :class="colClassFull">
                <div class="checkbox-display mb-5">
                  <vs-checkbox name="merchant" v-model.lazy="acceptMerchantContract">
                  </vs-checkbox>
                  <p>Acepto y firmo el <feather-icon icon="ExternalLinkIcon" svgClasses="w-6 h-6"/> <a class="inline-link-primary text-dark" target="_blank" rel="noopener"
                      @click="popUpMerchantContract = true"> Contrato de Inversión RedGirasol</a>.</p>
                </div>
                <div class="checkbox-display mb-5">
                  <vs-checkbox name="terms" v-model.lazy="acceptSecondaryMarketTerms">
                  </vs-checkbox>
                  <p>Acepto los <feather-icon icon="ExternalLinkIcon" svgClasses="w-6 h-6"/>
                    <a class="inline-link-primary text-dark" target="_blank" rel="noopener"
                      @click="popUpSecondaryMarketTermsContract = true"> Términos y Condiciones del Mercado
                      Secundario</a>.</p>
                </div>
                <div class="checkbox-display">
                  <vs-checkbox name="advertising" v-model.lazy="acceptAdvertising">
                  </vs-checkbox>
                  <p>Autorizo a RedGirasol que me envíe publicidad y que use mis datos para mejorar mi experiencia y recibir promociones que se ajusten a mis necesidades.</p>
                </div>
              </div>
            </div>

              <div class="vx-row mt-base">
                <div class="vx-col sm:w-full md:w-1/2 lg:w-2/3 w-full"></div>
                <div class="vx-col sm:w-full md:w-1/2 lg:w-1/3 w-full">
                  <vs-button id="pm_mex_11_merchant_contract_confirm_btn" class="w-full mt-5" @click="saveDataForm"
                    :disabled="(!acceptSecondaryMarketTerms || !acceptMerchantContract)">Continuar</vs-button>
                </div>
              </div>
          </div>
        </div>
      </vx-card>
    </div>
    <!-- Popup para ver terminos y condiciones de mercado secundario -->
    <vs-popup :active.sync="popUpSecondaryMarketTermsContract" title="Términos y condiciones"
      class="extended-popup header-primary">
      <latest-secondary-market-terms-conditions-contract />
    </vs-popup>

    <!-- Popup para ver contrato de comision mercantil -->
    <vs-popup :active.sync="popUpMerchantContract" title="Contrato de Comisión Mercantil"
      class="extended-popup header-primary">
      <latest-investor-merchant-contract :fill-user-data="true" />
    </vs-popup>
  </div>
</template>

<script>
import inputHelper from "@mixins/inputHelper";
import LatestInvestorMerchantContract from "@views/investor/contracts/LatestInvestorMerchantContract.vue";
import LatestAdvertisingContract from "@views/share/contracts/AdvertisingContract/LatestAdvertisingContract.vue";
import LatestSecondaryMarketTermsConditionsContract from "@views/investor/contracts/LatestSecondaryMarketTermsConditionsContract.vue";
import defaultParametersHelper from '@mixins/defaultParametersHelper';
import formatHelper from '@mixins/formatHelper';

export default {
  mixins: [inputHelper, defaultParametersHelper, formatHelper],
  components: {LatestInvestorMerchantContract, LatestAdvertisingContract, LatestSecondaryMarketTermsConditionsContract},
  props: ["onboardingStepData"],
  data() {
    return {
      acceptAdvertising: true,
      errorMssg: null,
      colClassFull: "vx-col w-full",
      currentLocation:null,
      contractInvestorMerchantType:3,
      locationOptions: {
        enableHighAccuracy: true,
        timeout: Infinity,
        maximumAge: 0
      },
      acceptSecondaryMarketTerms:true,
      acceptMerchantContract: true,
      popUpSecondaryMarketTermsContract: false,
      popUpMerchantContract: false,
      maxEffectiveInvestmentWithdrawalPerInvestorPerDay: null,
      minimumFixedInvestmentRequiredToSignUpSmMxn: null,
    };
  },
  async beforeMount() {
    const params = await this.getPublicParams(['max_effective_investment_withdrawal_per_investor_per_day', 'minimum_fixed_investment_required_to_sign_up_sm_mxn']);
    this.maxEffectiveInvestmentWithdrawalPerInvestorPerDay = params.max_effective_investment_withdrawal_per_investor_per_day;
    this.minimumFixedInvestmentRequiredToSignUpSmMxn = params.minimum_fixed_investment_required_to_sign_up_sm_mxn;
  },
  async mounted(){
    if('geolocation' in navigator) {
      await navigator.geolocation.getCurrentPosition(this.onSuccessLocation, this.onErrorLocation, this.locationOptions);
    }
  },
  computed: {
    currentOnboardingStep() {
      return this.onboardingStepData.onboarding_step;
    }
  },
  methods: {
    async saveDataForm() {
      this.showLoading(true, "Guardando información...");
      try {
        let geolocation = null;
        if(this.currentLocation){
          geolocation = "Lat: "+this.currentLocation.latitude+", Long: "+this.currentLocation.longitude;
        }
        let payload = {
          // onboarding_step: this.currentOnboardingStep,
          contractType: this.contractInvestorMerchantType,
          acceptAdvertising: this.acceptAdvertising,
          geolocation: geolocation
        };
        await axios.post(
          "/api/v2/investor/" + this.InvestorId + "/saveOnboardingStepPm",
          payload
        );
        this.showLoading(false);
        this.$emit("updated", 1);
      } catch (e) {
        this.showLoading(false);
        this.showError(e);
      }
    },
    showError(e) {
      this.warn(e);
      let err = "Ha ocurrido un error con la operación, intente más tarde";
      if (e.response && e.response.data && e.response.data.error) {
        err = e.response.data.error;
      }
      this.errorMssg = err;
    },
    async onSuccessLocation(pos){
      this.currentLocation = pos.coords;
    },
    onErrorLocation(err){
      // console.log(err);
    },
  },
};
</script>
<style scoped>
.vx-card.border-primary{
    border-style: solid;
    border-width: 1px;
}
.checkbox-display {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
</style>
